import script from "./Table.vue?vue&type=script&setup=true&lang=js"
export * from "./Table.vue?vue&type=script&setup=true&lang=js"

import "./Table.vue?vue&type=style&index=0&id=092bc8e1&lang=css"

const __exports__ = script;

export default __exports__